import { render } from "./ConfidentialAudience.vue?vue&type=template&id=0889ed16&scoped=true"
import script from "./ConfidentialAudience.vue?vue&type=script&lang=js"
export * from "./ConfidentialAudience.vue?vue&type=script&lang=js"

import "./ConfidentialAudience.vue?vue&type=style&index=0&id=0889ed16&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0889ed16"]])

export default __exports__